import { createI18n } from "vue-i18n"
import messages, { type MessageSchema } from "@/utils/locales/messages"

const i18n = createI18n<[MessageSchema], "fr" | "en">({
  legacy: false,
  locale: "fr",
  messages: messages,
  silentTranslationWarn: true,
  silentFallbackWarn: true,
})

export default i18n
